import type React from 'react'
import styles from './OfflineBanner.module.css'
import { WifiOffGlyph } from '../icons/SdGlyphs'
import { StationDetailsCopy } from '../copy'

/**
 * Offline `SectionHeader` — Figma node 7086:30437 (402×38). Injected
 * after the station header in the S5 offline state (spec §5.5). wifi-off
 * glyph (18×18) + title (`mediumPx16` / text-secondary, Figma truth) +
 * copy `Offline.Banner`. a11y id `station-details-offline-banner`.
 */
export function OfflineBanner({
  label = StationDetailsCopy.OfflineBanner,
}: {
  /** Offline banner text. @defaultValue {@link StationDetailsCopy.OfflineBanner} */
  label?: string
} = {}): React.ReactElement {
  return (
    <div className={styles.banner} data-testid="station-details-offline-banner">
      <WifiOffGlyph size={18} className={styles.icon} />
      <p className={styles.title}>{label}</p>
    </div>
  )
}
